import defaultConfig from "../config";

export const config = window.ssrConfig ?? defaultConfig ?? {};

export const posthogConfig = {
  enabled: config.posthogKey && config.posthogKey.length > 0,
  apiKey: config.posthogKey,
  options: {
    api_host: "https://us.posthog.com",
    debug: process.env.NODE_ENV === "development",
  },
};
